import {EvalEnv} from '@packages/systems/wfdl';

type Element = {
  text: boolean;
  type: string | null;
  id: string;
  children: string[];
  data: Record<string, string>;
};

type DynamoEnvValueType<T> =
  | null
  | {
      tag: 'Some';
      val: T;
    }
  | {
      tag: 'None';
      val: Record<string, never>;
    };

type Price = {
  value: number;
  unit: string;
  decimalValue: number;
  string: string;
};

export function createAddDynamoUtilsToEnv({
  dynamoPriceToText,
  dynamoPriceToListOfElements,
}: {
  dynamoPriceToText: (arg: DynamoEnvValueType<Price>) => string;
  dynamoPriceToListOfElements: (arg: DynamoEnvValueType<Price>) => Element[];
}) {
  return function addDynamoUtilsToEnv(
    env: EvalEnv.EvalEnvType
  ): EvalEnv.EvalEnvType {
    env = EvalEnv.insertValue(
      env,
      'dynamoPriceToListOfElements',
      dynamoPriceToListOfElements
    );
    return EvalEnv.insertValue(env, 'dynamoPriceToText', dynamoPriceToText);
  };
}
